// Core
import React from "react";

// Components
import Skillset from "./Skillset";
import Experience from "./Experience";
import Contacts from "./Contacts";
import Education from "./Education";

export default class Content extends React.Component {
    render () {
        return (
            <div className = 'content'>
                <div>
                    <div className = 'topRow'>
                        <Skillset />
                        <Experience />
                    </div>
                    <div className = 'bottomRow'>
                        <Contacts />
                        <Education />
                    </div>
                </div>
            </div>
        );
    }
}
